/* eslint-disable max-len */

import React, { memo } from 'react'

import { useCaseOptions } from 'Pods/ThreeDStudio/Components/MainPanel/Components/LeftSide/Components/ModelSettings/Components/UseCaseSelector/useCaseOptions'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import ClosedButtonSettings from 'Pods/ThreeDStudio/Shared/ClosedButtonSettings/ClosedButtonSettings'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

function CollapsedUseCaseRow() {
  const t = useTranslation()
  const selectedUseCase = useThreeDStudioStore(state => state.modelSettings.selectedUseCase)

  if (!selectedUseCase) {
    return null
  }

  const option = useCaseOptions.find(item => item.id === selectedUseCase)

  if (!option) {
    return null
  }

  return (
    <ClosedButtonSettings
      label={t('leftSide.useCase.title')}
      isActive
      buttonLabel={t(`leftSide.useCase.options.${option.id}.title`)}
    />
  )
}

export default memo(CollapsedUseCaseRow)
